import ListProcesses from "@/views/producer/reporting/process/ListProcesses.vue";
import ShowReports from "@/views/producer/reporting/process/ShowReports.vue";
import ShowReportsSummary from "@/components/views/producer/reporting/process/show_reports/Summary.vue";
import ShowReportsDetails from "@/components/views/producer/reporting/process/show_reports/Details.vue";
import ShowReportsWeekly from "@/components/views/producer/reporting/process/show_reports/Weekly.vue";
import ShowReportsCropFieldAnalysis from "@/components/views/producer/reporting/process/show_reports/CropFieldAnalysis.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "prod",
  role: "reporting",
  permission: "process"
});

export default [
  {
    path: "/prod/:producer_id/reporting/process/list_processes",
    name: routeName(""),
    redirect: { name: routeName("list_processes") }
  },
  {
    path: "/prod/:producer_id/reporting/process/list_processes",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/prod/:producer_id/reporting/process/:agro_exporter_process_id/show_reports",
    name: routeName("show_reports"),
    redirect: { name: routeName("show_reports_summary") },
    component: ShowReports,
    props: true,
    meta: META,
    children: [
      {
        path: "summary",
        name: routeName("show_reports_summary"),
        component: ShowReportsSummary,
        props: true
      },
      {
        path: "weekly",
        name: routeName("show_reports_weekly"),
        component: ShowReportsWeekly,
        props: true
      },
      {
        path: "details",
        name: routeName("show_reports_details"),
        component: ShowReportsDetails,
        props: true
      },
      {
        path: "crop_field_analysis",
        name: routeName("show_reports_crop_field_analysis"),
        component: ShowReportsCropFieldAnalysis,
        props: true
      }
    ]
  }
]
